import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";

const styles = {
  container: {
    marginRight: 8,
    display: "flex",
    fontSize: "0.875rem"
  },
  heading: {
    flex: 1,
    textAlign: "center"
  }
};

const MirroredBarChartHeader = props => (
  <div
    className={props.classes.container}
    style={{
      marginLeft: props.offset
    }}>
    <div className={props.classes.heading}>{props.leftSeries}</div>
    <div className={props.classes.heading}>{props.rightSeries}</div>
  </div>
);

MirroredBarChartHeader.propTypes = {
  offset: PropTypes.number,
  leftSeries: PropTypes.string.isRequired,
  rightSeries: PropTypes.string.isRequired
};

MirroredBarChartHeader.defaultProps = {
  offset: 0
};

export default withStyles(styles)(MirroredBarChartHeader);
